import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Event as NavigationEvent } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class NavigatorService {
  private routeIdx: number = 0;
  routeIndexChange: BehaviorSubject<number> = new BehaviorSubject<number>(this.routeIdx);

  constructor(private r: Router) {
    r.events
      .pipe(
        filter(
          (event: NavigationEvent) => {
            return (event instanceof NavigationStart);
          }
        )
      )
      .subscribe(
        (event: NavigationStart) => {
          if (event.restoredState) {
            this.routeIdx = event.restoredState.navigationId
          } else {
            this.routeIdx = event.id;
          }
          this.routeIndexChange.next(this.routeIdx);
        }
      )
  }

  navigateRoute(path: string, options?: { relativeTo?: ActivatedRoute, state?: { [key: string]: any } }) {
    if (options) {
      this.r.navigate([path], options);
    } else {
      this.r.navigate([path]);
    }
  }
}
